import './OSEL.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import ConfirmAction from 'extensions/confirm-action';
import {SummaryEvents} from 'extensions/checkout-pages';

export default class OSEL extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {
		new ConfirmAction('.js-confirm-exit', {
			message: 'Are you sure you want to exit checkout?',
			redirectUrl: this.pageContext.Basket_Url
		});

		new SummaryEvents();

		this.initPromoCodeEvents();
		this.initGTM();
	}

	async initPromoCodeEvents () {

		const promoCodeContainers = document.getElementsByClassName('g-checkout__order-summary-promo-form');

		if (!promoCodeContainers.length) {
			return;
		}

		const {PromoCodeEvents} = await import('extensions/checkout-pages');

		for (const promoCodeContainer of promoCodeContainers) {
			const input = promoCodeContainer.querySelector('input[type=text]');
			const submitElement = promoCodeContainer.querySelector('[type=submit]');

			if (input && submitElement) {
				new PromoCodeEvents(input, submitElement);
			}
		}

	}

	initGTM () {
		const form = document.getElementById('osel-form');

		if (!form) {
			return;
		}

		form.addEventListener('submit', () => this.sendGTMShippingOption(form));
	}

	sendGTMShippingOption (form) {
		const selectedShipping = form.querySelector('[name="ShippingMethod"]:checked');

		if (!selectedShipping) {
			return;
		}

		const checkoutOption = selectedShipping.getAttribute('data-gtm-name');
		const checkoutOptionValue = selectedShipping.getAttribute('data-gtm-value');

		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push({
			ecommerce: {
				// eslint-disable-next-line camelcase
				checkout_option: {
					actionField: {
						option: 'Shipping ' + checkoutOption,
						step: 5
					}
				}
			},
			event: 'shipping_selected',
			/* eslint-disable camelcase */
			ga_event_action: 'Checkout Option',
			ga_event_category: 'Ecommerce',
			ga_event_label: 'Shipping ' + checkoutOption,
			ga_event_noninteraction_hit: false,
			ga_event_value: '',
			shipping_option: checkoutOption,
			shipping_price: checkoutOptionValue
			/* eslint-enable camelcase */
		});
	}

}
